import { Home, ProductDetail, Navbar, Login, Signup, ProductForm } from '../pages'
import { useState } from 'react'
import { Routes, Route } from 'react-router-dom'
import shoe from '../Assets/logo.jpeg'
import blue from '../Assets/bluewhi.jpeg'
import white from '../Assets/white.jpeg'


const Router = ()=>  {

  const [cartItems, setCartItems] = useState([])

  function buttonAction(id, itemId, quantity, product){
    if(id === 'add'){
      if(cartItems.find((i) => i.id === product.id) || product === ''){
        setCartItems((prev) => prev.map((item) => item.id === itemId ? {...item, quantity: item.quantity + 1} : item))
      }else{
        setCartItems((prev) => [...prev, product])
      }
    }
    if(id === 'remove'){
      if(quantity > 1){
      setCartItems((prev) => prev.map((item) => item.id === itemId ? {...item, quantity: item.quantity - 1} : item))
      }else{
      setCartItems((prev) => prev.filter((i) => i.id !== itemId))
      }
    }
  }
  const [products, setProducts] = useState([
        {
            id:1,
            name:'Nike Jordans',
            price:69.99,
            img:shoe,
            quantity:1,
            rating: {
              "rate": 4,
              "count": 120
            },
            description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates tenetur eum voluptate soluta iusto nemo expedita! Ipsa aspernatur veritatis velit illo earum quaerat provident, officia vel iste exercitationem numquam impedit?',
            deliver: 'yes',
            condition:'Brand New',
            Material: 'Leather',
            stock:25,

        },
        {
            id:2,
            name:'Blue Nike Jordans',
            price:69.99,
            img:blue,
            quantity:1,
            rating: {
              "rate": 4,
              "count": 120
            },
            description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates tenetur eum voluptate soluta iusto nemo expedita! Ipsa aspernatur veritatis velit illo earum quaerat provident, officia vel iste exercitationem numquam impedit?',
            deliver: 'yes',
            condition:'Brand New',
            Material: 'Leather',
            stock:25,
        },{
            id:3,
            name:'White Nike Jordans',
            price:69.99,
            img:white,
            quantity:1,
            rating: {
              "rate": 4,
              "count": 120
            },
            description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates tenetur eum voluptate soluta iusto nemo expedita! Ipsa aspernatur veritatis velit illo earum quaerat provident, officia vel iste exercitationem numquam impedit?',
            deliver: 'yes',
            condition:'Brand New',
            Material: 'Leather',
            stock:25,
        },
    ])
  return (
    <Routes>
        <Route element={<Navbar items={cartItems} setItems={setCartItems} buttonAction={buttonAction}/>}>
            <Route path='/' element={<Home setProducts={setProducts} products={products} setCartItems={setCartItems} buttonAction={buttonAction}/>}/>
            <Route path='/products/:id' element={<ProductDetail products={products} setCartItems={setCartItems} buttonAction={buttonAction}/>}/>
            <Route path='/products/form' element={<ProductForm products={products}/>}/>
        </Route>
            <Route path='/login' element={<Login/>}/>
            <Route path='/signup' element={<Signup/>}/>
    </Routes>
  )
}

export default Router